const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const isMobile = Odigeo.SessionScope.flow === 'mobile';

module.exports = createWidgetFactory({
    name: 'boarding_options_wrapper_postbooking',
    viewClass: isMobile ? require('./view.mobile') : require('./view.desktop'),

    methods: {
        getTrackingData(event) {
            return this.getTrackingData(event);
        },
    },
});
